export const languages = import.meta.glob([
  '/locale/*.json',
  '!/locale/*_old.json',
]);

// MTXbudget: the French labels the community translation does not have yet.
export const mtxbudgetLanguages = import.meta.glob('./locale-mtxbudget/*.json');
